const track = {

    default: {
        eventCategory: 'web',
        eventAction: 'track',
        eventLabel: '?'
    },

    event(data) {
        let eventInfo = this.mergeFields(data)

        if (!window.ga || !eventInfo) {
            console.group('track event')
            console.log(eventInfo)
            console.groupEnd()
            return
        }

        ga('send', 'event', eventInfo)
    },

    mergeFields(data) {
        if(!data.eventLabel) data.eventLabel = this.getURN()
        return Object.assign({}, this.default, data)
    },

    getURN() {
        let origin = window.location.origin
        let href = window.location.href

        return href.replace(origin, '')
    }
}


export default track
